import React, { useEffect, useState } from 'react';
import '../../App.css';
import './Sculc.css';
import { useAuth } from '../../contexts/AuthContext.js';
import { useNavigate } from 'react-router-dom';
import {getFirestoreData} from '../../firebase/Firestore.js'

const Sculc = () => {
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const [isSculcPresenter, setIsSculcPresenter] = useState(false);
    const [isSculcApplicant, setIsSculcApplicant] = useState(false);

    useEffect(() => {
        const getUserData = async () => {
          if (currentUser) {
            const isSculcPresenter = await getFirestoreData('Users', currentUser.uid, 'sculc_presenter', false);
            setIsSculcPresenter(isSculcPresenter);
            const isSculcApplicant = await getFirestoreData('Users', currentUser.uid, 'sculc_applicant', false);
            setIsSculcApplicant(isSculcApplicant);
          }
        };
    
        getUserData();
      }, [currentUser]);

    const navToViewSubmission = () => {
        navigate('/sculc/view-submission'); // Navigate to View Submission if the user is an applicant
    };
    const navToSubmitAbstract = () => {
        navigate('/sculc/submit-abstract'); // Navigate to Submit Abstract if the user is not an applicant
    };
    const navToCongratulations = () => {
        navigate('/sculc/congratulations-page'); // Navigate to View Submission if the user is an applicant
    };


    return (
        <div className="sculc-page">
            <div className="sculc2025-header-container">
                <img
                    src="/images/new-sculc-header.png"
                    alt="Header"
                    className="sculc2025-header-image"
                />  
                <h1 className="sculc2025-title">SCULC 2027</h1>
            </div>
       
                    

                <div className="sculc-container">
          {/*
<div className="side-menu">
    <ul>
        <li><a href="#event-details">Event Details</a></li>
        <li><a href="#about-sculc">About SCULC</a></li>
        <li><a href="#keynote-speaker">Keynote Speaker</a></li>
        <li><a href="#conference-info">Program</a></li>
        <li><a href="#presentations">Presentations</a></li>
        <li><a href="#contact-info">Contact Info</a></li>
    </ul>
</div>
*/}
                    <div className="main-content">
                        <div id="event-details" className="event-details">
                            <div className="event-details-container">
                                <img
                                    src="/images/sculc-logo.png"
                                    alt="SCULC Logo"
                                    className="conference-logo"
                                />
                                <p className="event-date-time">
                                    <strong>Date: To Be Announced</strong><br />
                                    
                                </p>
                            </div>
                            {/* <p className="sculc25-zoom sculc-box">
                            <span className="zoom-icon-wrapper">
                                    <img 
                                    src="/images/zoom-icon.png" 
                                    alt="Zoom Icon" 
                                    className="zoom-icon"
                                    />
                                </span>
                                Join virtually here! :&nbsp;
                                <a 
                                    href="https://ucla.zoom.us/j/94995926899"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="sculc25-zoom-link"
                                >
                                    SCULC 2025 Zoom Link
                                </a>
                            </p> */}
                            {/* <p className="general-attendee sculc-box">
                                Please Check In Here! : <a 
                                    href="https://forms.gle/L7tZUkkVb3YkfYUt9"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="general-attendee-link"
                                >
                                    SCULC 2025 Check In 
                                </a>
                            </p> */}

                            {/* <h2 className="subtitle">EVENT DETAILS</h2> */}



                            {/* <p className="event-description">
                            Check-in will begin at 8:30 AM in the Campbell Hall Learning Pavilion lobby. 
                            Attendees are encouraged to dress in business casual attire.
                            For parking details and directions to Campbell Hall, see <a 
                                href="https://www.maps.ucla.edu/?id=2043#!ct/75713,67721,77384?m/696623?s/" 
                                className="embedded-link" 
                                target="_blank" 
                                rel="noopener noreferrer">this map
                            </a>. 
                            Parking can be paid at the pay station or through the <a 
                                href="https://apps.apple.com/us/app/parkmobile-park-pay-go/id365399299" 
                                className="embedded-link" 
                                target="_blank" 
                                rel="noopener noreferrer"> ParkMobile
                            </a> app.
                            Lunch will be served for all registered attendees, 
                            Attendance is free for all participants, presenters, and guests.
                            </p> */}
                            <p className="normal-text">
                                   <strong> Applications for SCULC 2027 have not yet opened, but if you are interested in presenting or attending don't hesitate to contact the organizers at <a href="mailto:bruinlinguists@gmail.com" className="email-link">bruinlinguists@gmail.com</a>. Be sure to specify in the subject line that your correspondence is related to SCULC 2027.</strong>
                                </p>
                            <div id="about-sculc" className="about-sculc">
                                <h2 className="subtitle">ABOUT SCULC</h2> 
                                <p className="event-description">
                                Southern California Undergraduate Linguistics Conference (SCULC) is an annual event hosted by the University of California, Los Angeles Linguistics Department and the undergraduate-run linguistics society, Bruin Linguists Society. 
                                </p>
                                <p className="event-description">
                                    Founded in 2010 by Bruin Linguists, SCULC was established to create a collaborative and educational environment for the undergraduate linguistics community. Throughout the years, it has been entirely student-run and free for all participants, presenters, and guests, supported by contributions from the linguistics community, the UCLA Linguistics Department, and individuals working to help enhance and expand the experience of undergraduates in linguistics.
                                </p>

                                {/* Mailing List */}
                            

                                    {/* Sponsors */}
                                    <p className="sponsors">Sponsored by the UCLA Department of Linguistics and the Bruin Linguists Society</p>
                            </div>
                            {/*
                            <div id="call-for-abstracts" className="call-for-abstracts">
                                <h2 className="subtitle">CALL FOR ABSTRACTS</h2>
                                <p className="event-description">
                                <strong>Deadline for Abstracts:</strong> March 15th, 2025<br />
                                <strong>Notifications:</strong> March 29th, 2025<br />
                                </p>
                                <p className="event-description">
                                Abstract submissions will be considered for poster and oral presentations. 
                                When submitting, you may indicate your preference for consideration for one 
                                or both types of presentations in the submission comment box. All abstracts 
                                will be reviewed anonymously. You may submit abstracts for projects that are 
                                either in progress or have been completed. Please ensure your abstracts are 
                                less than 500 words, figures and references not included in the word limit. 
                                </p>
                            </div>
                            

                                
                            {isSculcApplicant ? (
                                <button onClick={navToViewSubmission} className="blue-button"> View Submission Status</button>
                            ) : (
                                <button onClick={navToSubmitAbstract} className="blue-button"> Submit An Abstract</button>
                            )}
                            */}




                              
                                
                               
                            </div>
                        </div>
                    </div>
                </div>       
    );
};

export default Sculc;

                            // {isSculcPresenter ? (
                            //     <button onClick={navToCongratulations} className="blue-button">View Submission Status</button>
                            // ) : isSculcApplicant ? (
                            //     <button onClick={navToViewSubmission} className="blue-button">View Submission Status</button>
                            // ) : (
                            //     <> {/* Placeholder to maintain structure */} </>
                            // )}